import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Tag,
  Space,
  DatePicker,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  FileSearchOutlined,
  BarsOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import dayjs from "dayjs";
const { Text } = Typography;

export const PdiCadAcoes = () => {
  const navigate = useNavigate();
  const { id_competencia } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalDetalhes, setShowModalDetalhes] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);
  const [search, setSearch] = useState("");

  const [competencia, setCompetencia] = useState({});
  const [acao, setAcao] = useState(null);

  useEffect(() => {
    if (id_competencia) {
      carregarPdiCompetencia(id_competencia);
      listarPdisAcoes(id_competencia);
    }
  }, [id_competencia]);

  // CARREGAR
  const carregarPdiCompetencia = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/pdi_competencias/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) {
        setCompetencia(api?.response?.data);
      } else {
        navigate("/pdi");
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarPdisAcoes = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/pdi_acoes/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      navigate("/pdi/colaboradores");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarPdiAcoes = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/pdi_acoes/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarPdisAcoes(id_competencia);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarPdiAcao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/pdi_acoes/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarPdisAcoes(id_competencia);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarPdiAcao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/pdi_acoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) {
        setShowModal(true);
        resetForm();
        form.setFieldsValue({
          descricao: api?.response?.data?.descricao,
          observacoes: api?.response?.data?.observacoes,
          data_maxima_realizacao: dayjs(api?.response?.data?.data_maxima_realizacao),
        });
        setIdAlt(api.response.data.id);
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarPdiAcaoDetalhado = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/pdi_acoes/carregar_detalhes/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) {
        setShowModalDetalhes(true);
        setAcao(api?.response?.data);
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarPdi = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/pdi_acoes/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarPdisAcoes(id_competencia);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "descricao",
      title: "Ação",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      dataIndex: "observacoes",
      title: "Obs/Como?",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      dataIndex: "data_maxima_realizacao",
      title: "Prazo",
      width: 100,
      render: (_, e) => dayjs(e.data_maxima_realizacao).format("DD/MM/YYYY"),
      sorter: (a, b) =>
        dayjs(a.data_maxima_realizacao)
          .format("DD/MM/YYYY")
          ?.localeCompare(dayjs(b.data_maxima_realizacao).format("DD/MM/YYYY")),
    },
    {
      key: "status",
      title: "Status",
      width: 120,
      render: (_, e) => (e.status === 1 ? <Tag color="green">Concluído</Tag> : <Tag color="red">Pendente</Tag>),
      sorter: (a, b) =>
        (a.status === 1 ? "Concluído" : "Pendente")?.localeCompare(b.status === 1 ? "Concluído" : "Pendente"),
    },
    {
      key: "acoes",
      title: "Ações",
      width: 100,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Detalhes">
            <Button loading={loading} onClick={() => carregarPdiAcaoDetalhado(e.id)} icon={<BarsOutlined />} />
          </Tooltip>
          {e.status === 0 && (
            <React.Fragment>
              <Tooltip title="Editar">
                <Button loading={loading} onClick={() => carregarPdiAcao(e.id)} icon={<EditOutlined />} />
              </Tooltip>
              <Tooltip title="Excluir">
                <Button
                  loading={loading}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    modal.confirm({
                      title: "Deseja deletar este registro?",
                      okText: "Sim",
                      cancelText: "Cancelar",
                      onOk() {
                        deletarPdi(e.id);
                      },
                    });
                  }}
                />
              </Tooltip>
            </React.Fragment>
          )}
        </Space.Compact>
      ),
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_pdis_cad_competencias = id_competencia;
    formulario.data_maxima_realizacao = dayjs(formulario?.data_maxima_realizacao).format("YYYY-MM-DD");

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarPdiAcao(formulario);
    } else {
      cadastrarPdiAcoes(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.observacoes?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        dayjs(val.data_maxima_realizacao)?.format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase())
    );
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // RENDER ITEM
  const RenderItem = ({ titulo, descricao }) => {
    return (
      <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
        <Space direction="vertical" size={0}>
          <Text type="secondary" style={{ fontSize: 14 }}>
            {titulo}
          </Text>
          <Text style={{ fontSize: 16 }}>{descricao ?? "-"}</Text>
        </Space>
      </Col>
    );
  };

  // FORMULÁRIO
  const modalDetalhes = () => {
    return (
      <Modal
        title={<Text style={{ fontSize: 20 }}>{acao?.competencia}</Text>}
        open={showModalDetalhes}
        width={800}
        cancelText="Fechar"
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ loading: loading, type: "primary" }}
        onCancel={() => {
          setShowModalDetalhes(false);
          setAcao(null);
        }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <RenderItem titulo="Ação" descricao={acao?.descricao ?? ""} />
          <RenderItem titulo="Obs/Como?" descricao={acao?.observacoes ?? ""} />
          <RenderItem titulo="Data Prazo" descricao={dayjs(acao?.data_maxima_realizacao).format("DD/MM/YYYY") ?? ""} />
          {acao?.status === 1 && (
            <React.Fragment>
              <Divider />
              <RenderItem titulo="Avaliador" descricao={acao?.avaliador ?? ""} />
              <RenderItem titulo="Parecer Retorno" descricao={acao?.parecer_retorno ?? ""} />
              <RenderItem titulo="Data Parecer" descricao={dayjs(acao?.data_retorno).format("DD/MM/YYYY") ?? ""} />
            </React.Fragment>
          )}
        </Row>
      </Modal>
    );
  };

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Ação
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="descricao" label="Ação" rules={[{ required: true, message: "Digite a ação!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a ação" />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="data_maxima_realizacao"
                label="Prazo Realização"
                rules={[{ required: true, message: "Selecione a data!" }]}>
                <DatePicker
                  disabledDate={(current) => {
                    return current && current < dayjs(dayjs().format("YYYY-MM-DD"), "YYYY-MM-DD");
                  }}
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  size="large"
                  disabled={loading}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={24}>
              <Form.Item
                name="observacoes"
                label="Obs/Como?"
                rules={[{ required: true, message: "Informe as observações!" }]}>
                <Input.TextArea
                  size="large"
                  disabled={loading}
                  placeholder="Informe as observações"
                  rows={6}
                  autoSize={{ minRows: 5, maxRows: 7 }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      {modalDetalhes()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="PDI" onClickBack={() => navigate(`/pdi`)} />
            <HeaderTitle
              title="PDI Competências - Ações"
              subtitle={<Text italic>{competencia?.descricao}</Text>}
              icon={<FileSearchOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical" size={20}>
                <Space direction="vertical" size={0}>
                  <Text style={{ fontSize: 12 }} type="secondary">
                    Competência a ser desenvolvida:
                  </Text>
                  <Text style={{ fontSize: 14 }} strong>
                    {competencia?.descricao}
                  </Text>
                </Space>
                <Space wrap>
                  <Input
                    size="middle"
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                </Space>
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
                rowKey="id"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
